import React from "react";
import { Button } from "react-bootstrap";
import { API_BASE } from "APP_ROOT/constants";
import { stringify } from "query-string";
import T from "prop-types";

function DownloadUrl({ close, salesOrder, includeSoldTo }) {
  const downloadUrl = `${API_BASE}/sales_orders/${salesOrder.get(
    "id"
  )}/download_packing_slip?discreet=false`;

  const params = {
    include_sold_to: includeSoldTo
  };

  return (
    <Button
      bsStyle="primary"
      onClick={() => {
        window.open(`${downloadUrl}&${stringify(params)}`, "_blank");
        close();
      }}
    >
      Download
    </Button>
  );
}

DownloadUrl.propTypes = {
  close: T.func,
  salesOrder: T.instanceOf(Map)
};

export default DownloadUrl;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/DownloadPackingSlip/DownloadUrl.jsx